import { useState } from 'preact/hooks';
import { restorePurchases } from '../../utils/iap';
import { currentSession } from '../../core/Session';
import { useT } from '../../i18n';

/**
 * "Restore purchases" — the one button Apple insists a driver must be able to find without buying
 * anything first (non-consumable purchases). It lives in the MENU drawer, signed in or not, and on the
 * unlock page next to the price.
 *
 * Inside the iPhone app it goes through Apple's own restore; in a browser it re-syncs the purchases our
 * server holds for this device and account. Either way the engine comes back without paying twice.
 */
export function RestoreButton({ variant = 'button', onDone }: { variant?: 'button' | 'link'; onDone?: () => void }) {
  const t = useT();
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState('');
  const run = async () => {
    if (busy) return;
    setBusy(true);
    setNote(t('restoring'));
    const r = await restorePurchases();
    setBusy(false);
    if (!r.ok) {
      // eslint-disable-next-line no-console
      console.warn('restore failed:', r.message);
      setNote(t('restoreFailed'));
      return;
    }
    if (r.cars.length) {
      setNote(t('restoreDone'));
      await currentSession()?.refreshGrant().catch(() => null);
      onDone?.();
    } else {
      setNote(t('restoreNone'));
    }
  };
  return (
    <>
      <button
        class={variant === 'link' ? 'hwrow__link' : 'acctpanel__btn'}
        disabled={busy}
        onClick={() => void run()}
      >
        {busy ? t('restoring') : t('restorePurchases')}
      </button>
      {note && !busy && <p class="setup__note">{note}</p>}
    </>
  );
}
